import {jwtDecode} from "jwt-decode";

export function decodeJwt(token) {
    const decoded = jwtDecode(token);
    return decoded
}

export function isTesting(){
    return window.location.host.includes("localhost") || window.location.host.startsWith("192.168.0")
}